
export const root = {
    borderRadius: '{form.field.border.radius}'
};

export const colorScheme = {
    light: {
        root: {
            invalidBorderColor: '{form.field.invalid.border.color}'
        }
    },
    dark: {
        root: {
            invalidBorderColor: '{form.field.invalid.border.color}'
        }
    }
};

export default {
    root,
    colorScheme
};
